import Choice from "@/components/fields/Choice";
import {useAppState} from "@/store";
import {useEffect, useState} from "react";
import {useValidation} from "@/validation";
import FieldError from "@/components/FieldError";

export default function ChoiceMulti({stateKey, name, labels, values, allowMultiple}) {

    const {state, setState} = useAppState()
    const [touched, setTouched] = useState(false)

    const {isFieldValid, invalidMessage, showErrors} = useValidation()

    const handleChange = (name, {value, checked}) => {

        setState((s) => {

            if (!s[stateKey]) {
                s[stateKey] = {}
            }

            if (!s[stateKey][name]) {
                s[stateKey][name] = allowMultiple ? [] : null
            }

            if (allowMultiple) {
                if (checked) {
                    s[stateKey][name].push(value)
                } else {
                    s[stateKey][name] = s[stateKey][name].filter(i => i !== value)
                }
            } else {
                s[stateKey][name] = value
            }
        })
    }

    const valid = isFieldValid(`${stateKey}.${name}`)
    const invalidMsg = invalidMessage(`${stateKey}.${name}`)
    const showError = touched && !valid && invalidMsg

    useEffect(() => {
        if (showErrors) {
            setTouched(true)
        }
    }, [showErrors])


    return (
        <>
            <div className={"grid grid-cols-1 lg:flex lg:flex-wrap justify-center gap-y-[8px] gap-x-[16px] lg:gap-x-32px] mt-[16px] lg:mt-[24px]"}>
                {labels.map((label, index) => (
                    <Choice
                        key={index}
                        type={allowMultiple ? 'checkbox' : 'radio'}
                        name={`${stateKey}.${name}`}
                        value={values[index] || ''}
                        checked={allowMultiple ? state[stateKey]?.[name]?.includes(values[index]) : state[stateKey]?.[name] === values[index]}
                        onChange={target => handleChange(name, target)}
                    >
                        {label}
                    </Choice>
                ))}
            </div>
            {showError && (
                <div className={"text-center pt-2"}>
                    <FieldError message={invalidMsg} />
                </div>
            )}
        </>

    )
}
